import { render, staticRenderFns } from "./PastConversationsDrawer.vue?vue&type=template&id=7ff91af7"
import script from "./PastConversationsDrawer.vue?vue&type=script&lang=js"
export * from "./PastConversationsDrawer.vue?vue&type=script&lang=js"
import style0 from "./PastConversationsDrawer.vue?vue&type=style&index=0&id=7ff91af7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports